<template>
    <Modal v-model="visible" @on-ok="ok" @on-cancel="cancel" :loading="modalLoading" closable mask-closable
        :okText="getTranslation('k025')" :cancelText="getTranslation('b182')" :title="title" width="40">
        <WebSocket :url="webSocketUrl" @receive-message="receiveMessage"></WebSocket>
        <Row class="field-line" type="flex">
            <Col flex="3" class="flex-left">{{ getTranslation('b155') }}&nbsp;<Select class="one-field"
                v-model="selLibFrom" :filterable="true" :transfer="true" :placeholder="getTranslation('m034')"
                :not-found-text="getTranslation('b038')">
                <Option v-for="item in library" :value="item.id" :key="item.id">{{ item.id }}</Option>
            </Select> </Col>
            <Col flex="1" class="flex-middle">{{ getTranslation('b121') }} → {{ getTranslation('b124') }}</Col>
            <Col flex="3" class="flex-left"><Select class="one-field" v-model="selLibTo" :filterable="true"
                :transfer="true" :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                <Option v-for="item in library" :value="item.id" :key="item.id">{{ item.id }}</Option>
            </Select></Col>
            <Col flex="1" class="flex-left">{{ getTranslation('b121') }}</Col>
        </Row>
        <LineProgress v-if="exporting" :oneProgress="oneProgress" ></LineProgress>

        <div slot="footer">
        <Row type="flex" class="menu-actions">
          <Col flex="1" class="flex-right">
            <Button  type="default" icon="md-close" @click="cancel">{{ getTranslation('b182') }}</Button>&nbsp;
            <Button type="info" @click="ok" icon="md-cloud-download" :loading = "modalLoading">{{ getTranslation('k025') }}</Button>  
          </Col>
        </Row>
      </div> 
    </Modal>

</template>
<script>
/* eslint-disable */
import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { Modal, Row, Col, Select, Option, Button } from 'view-design';
import { mapGetters } from 'vuex'
import { exportFile, blobToString, postJsError } from '@/util/util.js'
import LineProgress from '@/components/LineProgress.vue';
import WebSocket from '@/components/WebSocket.vue';

export default {
    name: 'UserEdit', // 组件名称
    components: {
        Modal, Row, Col, Select, Option, LineProgress, Button, WebSocket
    },
    props: {
        propVisible: Boolean,
        mode: String,
        mac: Number,
        libSize: Number,
    },
    data() {
        return {
            modalLoading: true,
            library: [],
            selLibFrom: -1,
            selLibTo: -1,
            exporting: false,
            cancelDownload: true,
            oneProgress:{
                processed: 0,
                total: 0,
                status: 'waiting',
            },
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        visible: {
            get() { return this.propVisible },
            set(val) { this.$emit('input', val) }
        },
        title() {
            return this.getTranslation('b165');
        },
        webSocketUrl() {
            return API_URL['webSocket']+ "?mac=" + this.$route.query.mac;;
        },
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.library = this.createLibrary(this.libSize)
                this.selLibFrom = 0
                this.selLibTo = 0
                this.exporting = false
                this.modalLoading = false
                this.initSocket();
            }
        }
    },

    created() {
        
    },
    methods: {

        initSocket() {
            const mac = this.mac ?? this.$route.query.mac;
            this.$ws.updateUrl(API_URL["webSocket"] + '?mac=' + mac);
            // Prevent duplicate subscriptions
            this.$ws.unsubscribe?.('progressType', this._boundProgressHandler);
            this._boundProgressHandler = this.progressTypeHandler.bind(this);
            this.$ws.subscribe('progressType', this._boundProgressHandler);
        },
        async ok() {            
            if (this.mode !="1") {
                this.cancelDownload = false;
                this.exporting = true;
            }
            
            let params = {
                mac: this.mac,
                mode: this.mode,
                start: this.selLibFrom,
                end: this.selLibTo,
            }
            this.modalLoading = true;
            let exportUrl = API_URL["programExport"];
            const response = await axios.get(exportUrl, {
                responseType: 'blob',
                params: params,
                timeout: 300000
            })
            if (response.status == 200) {
                this.modalLoading = false;
                const contentType = response.headers['content-type'];
                if (contentType && contentType.includes('application/json')) {
                    blobToString(response.data).then(text => {
                        let msgData = JSON.parse(text);
                        if (msgData.msg) {
                            this.$Message.error(msgData.msg)
                        }
                    }).catch((err) => {
                        postJsError(err)
                        this.$Message.error(this.getTranslation('c001'));
                    });
                } else {
                    if (this.mode == "1" && !this.cancelDownload) {
                        exportFile(response)
                        this.modalLoading = false; 
                        this.visible = false;                       
                        this.resetModal();
                    }else {
                        exportFile(response)
                        this.modalLoading = false
                        this.visible = false;
                        this.resetModal();
                        
                    }
                }
            } else {
                this.$Message.error(this.getTranslation('c001'));
            }
            
            this.exporting = false;
        },

        resetModal() {
            this.$nextTick(() => {
                this.modalLoading = true;
            });
        },
        cancel() {
            this.visible = false;
            this.exporting = false;
            this.cancelDownload = true;
        },
        createLibrary(size) {
            let rs = []
            for (var i = 0; i < size; i++) {
                rs.push({ "id": i, "ProgramId": i })
            }
            return rs;
        },
        progressTypeHandler(msgData) {            
            if (msgData.type && msgData.type == 'exportTask') {
                this.oneProgress = msgData;
            }
        },
        receiveMessage(obj) {
            if (obj && obj.kind) {
                switch (obj.kind) {
                case 'progressType':
                    this.progressTypeHandler(obj.data);
                    break;
                default:
                    break;
                }
            }
        }

    },

}
</script>

<style scoped>
@import url("../../../assets/style/list.css");

.field-line {
    margin-bottom: 8px;
}

.desc-field {
    width: 60%;
}

.one-field {
    width: 85%;
}
</style>